// What to do when ICE drops: first an ICE restart (new candidates, same peer connection, so media and the data channel survive a network change), and only if that does not bring it back, the full reconnect (a new peer connection and offer).

export const ICE_RESTART_TIMEOUT_MS = 8000

export const iceRecoveryAction = (iceState, { enabled, restarts }) => {
	if (iceState !== 'disconnected' && iceState !== 'failed') return 'none'
	return enabled && restarts === 0 ? 'restart' : 'reconnect'
}
